import React from 'react';
import { SectionWrapper } from '../components/ui/SectionWrapper';
import { StatsBar } from '../components/sections/StatsBar';
import { WhatWeAreNotSection } from '../components/sections/WhatWeAreNotSection';
export function AboutPage() {
  return <div className="bg-white min-h-screen" data-id="element-315">
      <div className="py-20 px-6 bg-slate-50 text-center border-b border-slate-200" data-id="element-316">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-317">
          About D2D Guides
        </h1>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-318">
          The independent evaluation platform for the door-to-door industry.
        </p>
      </div>

      <StatsBar data-id="element-319" />

      <SectionWrapper data-id="element-320">
        <div className="max-w-3xl mx-auto prose prose-slate" data-id="element-321">
          <h2 data-id="element-322">Our Mission</h2>
          <p data-id="element-323">
            The door-to-door industry is full of opportunity, but it's also full
            of noise. Recruiting hype, biased reviews, and pay-to-play rankings
            make it hard to know who to trust.
          </p>
          <p data-id="element-324">
            D2D Guides exists to solve that problem. We provide unbiased,
            data-driven evaluations of companies, tools, and career paths so you
            can make informed decisions.
          </p>

          <h2 data-id="element-325">Who We Are</h2>
          <p data-id="element-326">
            We are a team of industry veterans, researchers, and analysts who
            believe that transparency is the key to the industry's long-term
            health.
          </p>
        </div>
      </SectionWrapper>

      <WhatWeAreNotSection data-id="element-327" />
    </div>;
}